module.exports = __webpack_public_path__ + "img/David Leonardi.4e022171.jpg";